import React from 'react';

export interface DataTableToolbarSeparatorProps {}

export const DataTableToolbarSeparator: React.FC<DataTableToolbarSeparatorProps> = ({}) => {
  return <div className="h-6 w-[1px] bg-voxel-gray-200 mx-1" />;
};

export default DataTableToolbarSeparator;
